exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left-bg-modal[data-v-da347932]{z-index:-1;background:linear-gradient(90.39deg,rgba(4,17,24,.9) 12.55%,rgba(4,16,23,.63) 55.92%,rgba(4,18,26,0) 99.62%)}", ""]);

// exports
